import { cva, type VariantProps } from "cva";

export const bodyStyles = cva({
  variants: {
    size: {
      hero: "text-body-hero",
      "1": "text-body-1",
      "2": "text-body-2",
      "3": "text-body-3",
      "4": "text-body-4",
      caption: "text-caption",
    },
    weight: {
      normal: "font-normal",
      medium: "font-medium",
      bold: "font-bold",
    },
  },
});

export type BodyStylesProps = VariantProps<typeof bodyStyles>;
